import axios from 'axios'
const config = require('../../config');
const state = {}
const getters = {}
const mutations = {}
const actions = {
  async checkScan (_, obj) {
    let query = `${config.baseUrl}/client/get/info`;
    const params = [];
    if (obj.trId != null) {
      params.push(`&trId=${obj.trId}`);
    } 
    if (obj.barcode != null) {
      params.push(`&barcode=${obj.barcode}`);
    }
    if (obj.eiId != null) {
      params.push(`&eiId=${obj.eiId}`);
    }
    if (params.length > 0) {
      query += `?${params.join('&')}`;
    }
    const resp = await axios.get(query);
    return resp.data;
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}